import App from '../../templates/src/App/App.js';
import FormLabels from "./Labels/Form.labels";
import FormValidation from "./Validation/FormValidation";
import FormDebug from "./Debug/Form.debug.js";
import FormResult from "./Validation/FormResult";
import Multiselect from "./Inputs/Select/Multiselect";
import Chosen from "./Inputs/Select/Chosen";
import FormDataLayer from "./Form.datalayer";
import FormAgreement from "./Templates/agreement/Form.agreement.js";
import FormRating from "./Inputs/Rating/Rating";
import ServisForm from "./Templates/Service/ServisForm";

const Form = {

    init() {
        this.forms = $('form[form]');
        if (!this.forms.length) return;

        this.forms.each((i, el) => {
            this.bind($(el));
        });
    },

    bind(form) {
        if(form.is('.bound')) return;
        form.addClass('bound');

        if (App.debug) console.log('Form.bind()', form);
        FormLabels.init(form);
        FormValidation.init(form);
        FormDebug.init(form);
        Multiselect.init(form);
        Chosen.init(form);
        FormDataLayer.init(form);
        FormAgreement.init();
        FormRating.init(form);
        ServisForm.init();

        form.find('button.submit').click((evt) => {
            Form.submit(form);
        })

        form.submit((evt) => {
            evt.preventDefault();
        });

        form.change((evt) => {
            if (!window.useDatalayer) return;

            if (typeof dataLayer_form !== "undefined") {
                if (!FormDataLayer.isPushed()) {
                    window.dataLayer.push(dataLayer_form);
                    // console.info('dataLayer event „' + dataLayer_form.event + '“ pushed');
                }
            }
        })
    },

    submit(form) {
        if (Form.processing || !FormValidation.check(form)) return false;

        Form.processing = true;

        this.initRecaptcha(form);
        // this.send(form);
        return false;
    },

    initRecaptcha(form) {
        grecaptcha.ready(function () {
            grecaptcha.execute(RECAPTCHA_SITEKEY, {action: 'submit'}).then(function (recaptchaToken) {
                $(form).append('<input type="hidden" name="g-recaptcha-response" value="' + recaptchaToken + '">');
                Form.send(form);
            });
        });
    },

    beforeSend(form) {
    },

    send(form) {
        $(form).find('.button.submit').attr('load', 'button');

        $.ajax({
            data: new FormData($(form)[0]),
            processData: false,
            contentType: false,
            url: $(form).attr('action') || document.location,
            type: $(form).attr('method') || 'POST',

            beforeSend: function (form) {
                Form.beforeSend(form);
            },

            success: function (response) {
	        	Form.success(form, JSON.parse(response));
            },

            error: function (response, textStatus, jqXHR) {
				Form.error(form, JSON.parse(response), textStatus, jqXHR);
            }
        });

    },

    success(form, response) {
        Form.processing = false;
        $(form).find('.button.submit').removeAttr('load');

        if (!response.success) {
            FormResult.show('error', form, response.error);
            console.error(response.error);
            return;
        }

        const settings = $.parseJSON(form.attr('settings'));

        if (App.debug) {
            console.log('Form.send() -> success');
            console.log('response', response);
            console.log('form', form);
        }

        if (settings.afterSubmit && settings.afterSubmit.length) {
            const data = settings.afterSubmit.split('.');

			const CLASS = window[data[0]];
            const method = data[1];

            if (typeof CLASS === 'object' && typeof CLASS[method] === 'function') {
                CLASS[method](form, response.data);
            }
        }

        Form.reset(form);

        if (!settings.hideDefaultResult) {
            FormResult.show('success', form);
        }

        if (settings.redirect_to) {
            document.location = settings.redirect_to;
            // Router.route("", Form.settings.redirect_to)
        }
    },

    error(form, response, textStatus, jqXHR) {
        Form.processing = false;
        $(form).find('.button.submit').removeAttr('load');

        if (!App.debug) {
            console.error(response.error);
            console.error(textStatus);
            console.error(jqXHR);
        }

        FormResult.show('error', form);

    },

    afterSubmit() {
        console.log('afterSubmit');
    },

    reset: function (form) {
        form.find('.input').removeClass('filled invalid valid');
        form.find('.input.file .filename span').text('');
        FormRating.reset(form);

        form.find(':input')
            .removeAttr('checked')
            .removeAttr('selected')
            .not(':button, :submit, :reset, :hidden, :radio, :checkbox')
            .val('');

        form.find('select').val("");
        form.find('select.chosen').trigger("chosen:updated");
        $(form)[0].reset();
    },
}

export default Form;